import { render, staticRenderFns } from "./detailProgress.vue?vue&type=template&id=456a91e2&scoped=true&"
import script from "./detailProgress.vue?vue&type=script&lang=js&"
export * from "./detailProgress.vue?vue&type=script&lang=js&"
import style0 from "./detailProgress.vue?vue&type=style&index=0&id=456a91e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a91e2",
  null
  
)

export default component.exports